import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "@/context/LanguageContext";
import { useSeo } from "@/lib/api";
import BrandLogo from "@/components/common/BrandLogo";

export default function NotFound() {
  const { t, to, lang } = useLang();
  useSeo({ title: `404 — NEKASSUR`, description: t.notFound.text });
  const homeAria = lang === "en" ? "NEKASSUR — Back to homepage" : "NEKASSUR — Retour à la page d'accueil";

  const suggestions = [t.nav.particuliers, t.nav.professionnels, t.nav.epargne, t.nav.contact];

  return (
    <section className="flex min-h-[70vh] items-center bg-nek-light" data-hide-appointment>
      <div className="nek-container text-center">
        <Link
          to={to("")}
          aria-label={homeAria}
          data-testid="notfound-logo-link"
          className="mb-8 inline-flex rounded-md p-1 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-nek-teal focus-visible:ring-offset-2"
        >
          <BrandLogo className="mx-auto h-10 w-auto" />
        </Link>
        <p className="font-heading text-7xl font-extrabold text-nek-blue sm:text-8xl">404</p>
        <h1 className="mt-4 text-2xl font-heading font-bold text-nek-navy sm:text-3xl">{t.notFound.title}</h1>
        <p className="mx-auto mt-3 max-w-md text-nek-gray">{t.notFound.text}</p>
        <Link to={to("")} className="btn-coral mt-8">{t.notFound.cta}</Link>
        <div className="mt-10">
          <p className="text-sm font-semibold text-nek-navy">{t.notFound.suggestionsTitle}</p>
          <div className="mt-3 flex flex-wrap justify-center gap-2">
            {suggestions.map((s) => (
              <Link key={s.path} to={to(s.path)} className="rounded-full border border-nek-border bg-white px-4 py-2 text-sm font-medium text-nek-navy hover:border-nek-blue">{s.label}</Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
